var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMultipleGroupStreamlineFlex2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0512 20.7543H19.6962C22.0334 20.7543 23.347 18.2554 21.4018 16.9598C20.621 16.4399 19.7702 16.017 18.8665 15.7084",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 12.4661C15.0927 12.5726 15.5425 12.627 16.0347 12.627C18.5382 12.627 19.9465 11.2188 19.9465 8.71522C19.9465 6.21164 18.5382 4.80341 16.0347 4.80341C16.0056 4.80341 15.9765 4.8036 15.9477 4.80398",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8836 16.6426C17.9916 18.0467 16.5682 20.7543 14.0355 20.7543H4.52457C1.99189 20.7543 0.568504 18.0467 2.67644 16.6426C4.5672 15.3833 6.83791 14.6494 9.28004 14.6494C11.7222 14.6494 13.9929 15.3833 15.8836 16.6426Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28324 11.8641C12.0412 11.8641 13.5926 10.3128 13.5926 7.55479C13.5926 4.79679 12.0412 3.24542 9.28324 3.24542C6.52525 3.24542 4.97388 4.79679 4.97388 7.55479C4.97388 10.3128 6.52525 11.8641 9.28324 11.8641Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMultipleGroupStreamlineFlex2);
export default __webpack_public_path__ + "static/media/User-Multiple-Group--Streamline-Flex 2.3ed2fecff2464720574316adc7cacded.svg";
export { ForwardRef as ReactComponent };